// extracted by mini-css-extract-plugin
export var buttonContainer = "_8d-1";
export var fontSizeSelect = "_8d-3";
export var formatSelect = "_8d-2";
export var formats = "_8d-4";
export var hidden = "_8d-5";
export var icon = "_8d-6";
export var select = "_8d-0";